function normalizeEnvValue(rawValue, fallback = '') {
  if (rawValue === undefined || rawValue === null) {
    return fallback;
  }

  let nextValue = String(rawValue)
    .replace(/\\r\\n|\\n|\\r/g, '')
    .replace(/[\r\n]+/g, '')
    .trim();

  if (
    (nextValue.startsWith('"') && nextValue.endsWith('"')) ||
    (nextValue.startsWith("'") && nextValue.endsWith("'"))
  ) {
    nextValue = nextValue.slice(1, -1).trim();
  }

  return nextValue || fallback;
}

function readEnvString(name, fallback = '') {
  return normalizeEnvValue(process.env[name], fallback);
}

function readEnvFlag(name, fallback = false) {
  const normalized = readEnvString(name, '');
  if (!normalized) {
    return fallback;
  }

  return normalized.toLowerCase() === 'true';
}

function readEnvEnabledFlag(name, fallback = true) {
  const normalized = readEnvString(name, '');
  if (!normalized) {
    return fallback;
  }

  return normalized.toLowerCase() !== 'false';
}

export const FEATURE_FLAGS = {
  dashboard: readEnvEnabledFlag('REACT_APP_REFACTOR_DASHBOARD', true),
  campaigns: readEnvEnabledFlag('REACT_APP_REFACTOR_CAMPAIGNS', true),
  invoices: readEnvEnabledFlag('REACT_APP_REFACTOR_INVOICES', true),
  quotations: readEnvEnabledFlag('REACT_APP_REFACTOR_QUOTATIONS', true),
  estimatedInvoices: readEnvEnabledFlag('REACT_APP_REFACTOR_ESTIMATED_INVOICES', true),
  products: readEnvEnabledFlag('REACT_APP_REFACTOR_PRODUCTS', true),
  customers: readEnvEnabledFlag('REACT_APP_REFACTOR_CUSTOMERS', true),
  taxes: readEnvEnabledFlag('REACT_APP_REFACTOR_TAXES', true),
  settings: readEnvEnabledFlag('REACT_APP_REFACTOR_SETTINGS', true),
  documentLayouts: readEnvEnabledFlag('REACT_APP_ENABLE_DOCUMENT_LAYOUTS', true),
  ledger: readEnvEnabledFlag('REACT_APP_REFACTOR_LEDGER', true),
  customerPortal: readEnvFlag('REACT_APP_ENABLE_CUSTOMER_PORTAL', false),
  copilot: readEnvFlag('REACT_APP_ENABLE_COPILOT', false),
};

export const ENABLE_AUTH = readEnvEnabledFlag('REACT_APP_ENABLE_AUTH', true);
export const ENABLE_CUSTOMER_PORTAL = FEATURE_FLAGS.customerPortal;
export const ENABLE_COPILOT = FEATURE_FLAGS.copilot;
export const ENABLE_DASHBOARD_SLICE_API =
  FEATURE_FLAGS.dashboard && readEnvEnabledFlag('REACT_APP_ENABLE_DASHBOARD_SLICE_API', true);
export const AUTH_PROVIDER = readEnvString('REACT_APP_AUTH_PROVIDER', 'hybrid').toLowerCase();
export const ADMIN_AUTH_PROVIDER = readEnvString('REACT_APP_ADMIN_AUTH_PROVIDER', 'hybrid').toLowerCase();
export const CUSTOMER_PORTAL_AUTH_PROVIDER =
  readEnvString('REACT_APP_CUSTOMER_PORTAL_AUTH_PROVIDER', 'clerk').toLowerCase();
export const CLERK_PUBLISHABLE_KEY = readEnvString('REACT_APP_CLERK_PUBLISHABLE_KEY', '');
export const CLERK_SIGN_IN_ROUTE =
  readEnvString('REACT_APP_CLERK_SIGN_IN_ROUTE', '/auth/clerk/sign-in');
export const WORKSPACE_CLERK_ENABLED =
  ENABLE_AUTH && AUTH_PROVIDER !== 'local' && Boolean(CLERK_PUBLISHABLE_KEY);
export const ADMIN_CLERK_ENABLED =
  ENABLE_AUTH && ADMIN_AUTH_PROVIDER !== 'local' && Boolean(CLERK_PUBLISHABLE_KEY);
export const CUSTOMER_PORTAL_CLERK_ENABLED =
  ENABLE_AUTH &&
  ENABLE_CUSTOMER_PORTAL &&
  CUSTOMER_PORTAL_AUTH_PROVIDER !== 'local' &&
  Boolean(CLERK_PUBLISHABLE_KEY);
export const CLERK_ENABLED =
  WORKSPACE_CLERK_ENABLED || ADMIN_CLERK_ENABLED || CUSTOMER_PORTAL_CLERK_ENABLED;
export const CLERK_AFTER_SIGN_OUT_URL =
  readEnvString('REACT_APP_CLERK_AFTER_SIGN_OUT_URL', '/login');
export const CLERK_INVITATION_ROUTE =
  readEnvString('REACT_APP_CLERK_INVITATION_ROUTE', '/accept-invitation');
export const CUSTOMER_PORTAL_CLERK_SIGN_IN_ROUTE =
  readEnvString(
    'REACT_APP_CUSTOMER_PORTAL_CLERK_SIGN_IN_ROUTE',
    '/customer-portal/auth/sign-in'
  );

const DEFAULT_API_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:5001/api'
    : 'https://hatched-billing-backend-prod-v2.vercel.app/api';

function resolveApiBaseUrl() {
  const configuredBaseUrl = readEnvString('REACT_APP_API_BASE_URL', '');
  if (configuredBaseUrl) {
    return configuredBaseUrl;
  }

  return DEFAULT_API_BASE_URL;
}

export const API_BASE_URL = resolveApiBaseUrl();

export const APP_TITLE = 'Hatched Billing';

export const __testables = {
  normalizeEnvValue,
  readEnvFlag,
  readEnvEnabledFlag,
  readEnvString,
};
